import { render, staticRenderFns } from "./capacitacion-induccion-editar.vue?vue&type=template&id=2a2f167e&scoped=true&"
import script from "./capacitacion-induccion-editar.vue?vue&type=script&lang=js&"
export * from "./capacitacion-induccion-editar.vue?vue&type=script&lang=js&"
import style0 from "./capacitacion-induccion-editar.vue?vue&type=style&index=0&id=2a2f167e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a2f167e",
  null
  
)

export default component.exports